import { ICreateOptionDto } from '@/api/services/options.service';
import { OptionType } from '@/enums/OptionType';

/**
 * Starting points of «Crear un grupo nuevo» (plan §5.13). Each one only sets
 * the group's rule; the owner names it and adds the options in the editor.
 */
export type TGroupTemplate =
  | 'chooseOne'
  | 'chooseMany'
  | 'pricedExtras'
  | 'removeIngredients'
  | 'blank';

export const GROUP_TEMPLATES: readonly TGroupTemplate[] = [
  'chooseOne',
  'chooseMany',
  'pricedExtras',
  'removeIngredients',
  'blank',
];

const RULES: Record<
  TGroupTemplate,
  Pick<ICreateOptionDto, 'type' | 'multiple' | 'mandatory' | 'min' | 'max'>
> = {
  // Single-choice groups carry no min/max (the API rejects them): «mandatory»
  // is what makes the choice required.
  chooseOne: {
    type: OptionType.Choose,
    multiple: false,
    mandatory: true,
    min: null,
    max: null,
  },
  chooseMany: {
    type: OptionType.Choose,
    multiple: true,
    mandatory: false,
    min: 0,
    max: 3,
  },
  pricedExtras: {
    type: OptionType.Add,
    multiple: true,
    mandatory: false,
    min: 0,
    max: 5,
  },
  removeIngredients: {
    type: OptionType.Choose,
    multiple: true,
    mandatory: false,
    min: 0,
    max: null,
  },
  blank: {
    type: OptionType.Choose,
    multiple: false,
    mandatory: false,
    min: null,
    max: null,
  },
};

/** A new group draft for `V2ModalOption` (deferred mode). */
export function groupTemplateDraft(template: TGroupTemplate): ICreateOptionDto {
  return {
    title: '',
    description: null,
    main: false,
    optionItems: [],
    ...RULES[template],
  };
}
